import { React, useEffect, useState } from "react";
import img_libelula from "../../../assets/images/img_libelula.png";
import ico_libelula from "../../../assets/icons/ico_libelula.svg";
import VideoGroupsBanner from "../../../components/videoGroupsBanner";
import GroupInfoSection from "../../../components/groupInfoSection";
import GoToPage from "../../../components/goToPage";
import GroupsVideoFooter from "../../../components/groupsVideoFooter";
const AquaticInvertebratesScreen = ({ handle }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const rio = "https://drive.google.com/uc?export=download&id=18cKmepCCQHfzebDBMVnVCjy_XAgd-AkU";
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    handle(false);
    return () => handle(true);
  }, [handle]);

  return (
    <div className="bg-[#002E0F] h-full">
      {width > 1300 ? (
        <div>
          <div className="grid overflow-hidden lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 lg:grid-rows-1  gap-0 w-full h-full bg-[#002E0F] absolute">
            <div className="relative w-full lg:h-full">
              <div className="blur-sm h-full w-full">
                <VideoGroupsBanner videoSource={rio} left="-35%" />
              </div>

              <div className="h-full bg-[#002E0F] bottom-0 right-0 absolute z-30 pl-24 pt-10 pr-36">
                <GoToPage
                  page="/grupos"
                  side="left"
                  name="Atrás"
                  fontsize="text-lg"
                  textColor="text-white"
                  borderType="border-b-2"
                  borderColor="border-white"
                  iconSize="h-4"
                  iconColor="invert"
                  iconMargin="mr-5"
                ></GoToPage>
              </div>
              <img
              
                src={img_libelula}
                alt=""
                className="w-full bottom-0 absolute z-40 pr-52 pl-20"
              />
            </div>

            <GroupInfoSection
              icon={ico_libelula}
              title={
                <p>
                  Invertebrados <br /> Acuáticos
                </p>
              }
              subTitle=""
              textFirstTab={
                <p>
                  Este grupo está compuesto por animales de distintos grupos
                  taxonómicos, incluyendo insectos, arañas, cangrejos, moluscos
                  y camarones, entre otros.
                </p>
              }
              textSecondTab={
                <p>
                  Los macroinvertebrados acuáticos son indicadores biológicos
                  por excelencia de la calidad de los cuerpos de agua
                  superficiales. Los macroinvertebrados se caracterizan por
                  poseer una sensibilidad diferenciada a la contaminación
                  acuática. Esto significa que algunos grupos solo se
                  desarrollan en aguas de alta calidad, mientras que otros
                  abundan en cuerpos de agua altamente contaminados. Son, por
                  tanto, bioindicadores natos; unos, de aguas limpias, y otros,
                  de agua sucias. Esta metodología, aunque muy rigurosa, se
                  presta para desarrollar monitoreo participativo con las
                  comunidades.
                </p>
              }
              textThirdTab={
                <p>
                  Se recomienda monitorear macroinvertebrados en los cuerpos de
                  agua asociados a sistemas productivos, a nivel de plantación,
                  fincas y paisaje, con el fin de evaluar la calidad del agua de
                  los ecosistemas acuáticos a través del uso del índice
                  biológico Biological Monitoring Working Party (BMWP) adaptado
                  a cada país, o algún índice similar. Se debe hacer el
                  monitoreo cada 6 meses en cada punto de muestreo.
                </p>
              }
            ></GroupInfoSection>
          </div>
        </div>
      ) : (
        <div className="min-h-[100vh] grid grid-cols-1 h-full">
          <div className=" bg-[#002E0F] left-0  lg:pl-24 md:pl-10 sm:pl-10 pl-10 pt-32 pr-36 h-fit">
            <GoToPage
              page="/grupos"
              side="left"
              name="Atrás"
              fontsize="text-lg"
              textColor="text-white"
              borderType="border-b-2"
              borderColor="border-white"
              iconSize="h-4"
              iconColor="invert"
              iconMargin="mr-5"
            ></GoToPage>
          </div>
          <div  style={{"z-index":"1"}}>
          <GroupInfoSection
              icon={ico_libelula}
              title={
                <p>
                  Invertebrados <br /> Acuáticos
                </p>
              }
              subTitle=""
              textFirstTab={
                <p>
                  Este grupo está compuesto por animales de distintos grupos
                  taxonómicos, incluyendo insectos, arañas, cangrejos, moluscos
                  y camarones, entre otros.
                </p>
              }
              textSecondTab={
                <p>
                  Los macroinvertebrados acuáticos son indicadores biológicos
                  por excelencia de la calidad de los cuerpos de agua
                  superficiales. Los macroinvertebrados se caracterizan por
                  poseer una sensibilidad diferenciada a la contaminación
                  acuática. Esto significa que algunos grupos solo se
                  desarrollan en aguas de alta calidad, mientras que otros
                  abundan en cuerpos de agua altamente contaminados. Son, por
                  tanto, bioindicadores natos; unos, de aguas limpias, y otros,
                  de agua sucias. Esta metodología, aunque muy rigurosa, se
                  presta para desarrollar monitoreo participativo con las
                  comunidades.
                </p>
              }
              textThirdTab={
                <p>
                  Se recomienda monitorear macroinvertebrados en los cuerpos de
                  agua asociados a sistemas productivos, a nivel de plantación,
                  fincas y paisaje, con el fin de evaluar la calidad del agua de
                  los ecosistemas acuáticos a través del uso del índice
                  biológico Biological Monitoring Working Party (BMWP) adaptado
                  a cada país, o algún índice similar. Se debe hacer el
                  monitoreo cada 6 meses en cada punto de muestreo.
                </p>
              }
            ></GroupInfoSection>
          </div>
          <div className="relative w-full lg:h-full flex justify-center">
            <GroupsVideoFooter videoSource={rio} />
           
            <img
            
              src={img_libelula}
              alt=""
              className="lg:w-[30rem] md:w-[25rem] sm:w-[15rem] w-[15rem] h-fit-content bottom-0 absolute "
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AquaticInvertebratesScreen;
